import React from 'react'
import Logo from "../../assets/img/brand/artur.svg";
import { useTranslation } from 'react-i18next';
import { useUnsubscribeInvitations } from '../../hooks/invitations/Invitations';
import { useEffect } from 'react';

export default function UnsubscribePage() {
    const { t } = useTranslation();

    const { mutate, isError, data } = useUnsubscribeInvitations();

    const [vendorName, setVendorName] = React.useState("");
    const [massage, setMassage] = React.useState("");
    const [status, setStatus] = React.useState("PENDING");

    useEffect(() => {
        if(status === "PENDING") 
            mutate();
        if(isError) 
            setStatus("FAILED");

        if (data) { 
            if(data.status === "SUCCESS") {
                setVendorName(data.vendorName);
                setStatus("SUCCESS");
            } else {
                setMassage(data.message);
                setStatus("FAILED");
            }
        }
            
    }, [data, isError, mutate, status])



    return (<>
        <div className="mailUnsubscribe">
            <header>
                <img src={Logo} alt="Artur.com" title="Artur.com" />
            </header>
            <div className="contentWrap">
                {status === "PENDING" &&
                    <div className="contentInner">
                        <h3>{t("unSub.pen")}</h3>
                    </div>
                }

                {status === "SUCCESS" && vendorName &&
                    <div className="contentInner">
                        <h3>{t("unSub.suc")}</h3>
                        <p>{t("unSub.co")} {vendorName} {t("unSub.no")}</p>
                    </div>
                }

                {status === "FAILED" &&
                    <div className="contentInner">
                        <h3>{t("unSub.er")}</h3>
                        <p>{massage}</p>
                        <p>{t("unSub.turn")}</p>
                    </div>
                }
            </div>
        </div>
    </>)
}
